import React, { useEffect } from 'react';

import { queryClient } from '@/data';
import { useSbkBetSlipStore } from '@/feature/betslip-sbk/hooks/use-sbk-betslip-store';
import { authUserKeys } from '@/hooks/use-auth-user-config';
import { AcceptMultiplierChanges, useAuthUserSettings, useUpdateUserSettings } from '@/hooks/use-auth-user-settings';
import { logger } from '@/utils/logging';

import { CustomSwitch } from './CustomSwitch';

const LOG_TAG = '[higher multiplier switch]: ';

export const AcceptHigherMultiplerSwitch = () => {
    const { data } = useAuthUserSettings();
    const { mutateAsync: updateUserSettings } = useUpdateUserSettings();
    const acceptAllMultiplierChanges = data?.accept_multiplier_changes === AcceptMultiplierChanges.ALL;
    const acceptHigherMultiplierChanges = data?.accept_multiplier_changes === AcceptMultiplierChanges.HIGHER;
    const updateBetSlipUserSettings = useSbkBetSlipStore(state => state.actions.updateUserSettings);
    const isEnabled = acceptHigherMultiplierChanges || acceptAllMultiplierChanges;
    useEffect(() => {
        if (data) {
            updateBetSlipUserSettings(data);
        }
    }, [acceptHigherMultiplierChanges, acceptAllMultiplierChanges, data, updateBetSlipUserSettings]);

    const handleHigherMultiplierChangeToggle = async () => {
        const newEnabledState = !isEnabled;
        if (acceptAllMultiplierChanges && !newEnabledState) {
            return;
        }
        const acceptMultiplierChangesValue = newEnabledState
            ? AcceptMultiplierChanges.HIGHER
            : AcceptMultiplierChanges.NONE;
        try {
            await updateUserSettings({ accept_multiplier_changes: acceptMultiplierChangesValue });
            await queryClient.invalidateQueries({ queryKey: authUserKeys.settings() });
        } catch (error: unknown) {
            logger.error(LOG_TAG, 'Error updating user settings', error);
            return;
        }
    };

    return <CustomSwitch val={isEnabled} handleOnPress={handleHigherMultiplierChangeToggle} />;
};
